import { render, staticRenderFns } from "./PortfolioBoxLayoutPage.vue?vue&type=template&id=365cdd52&"
import script from "./PortfolioBoxLayoutPage.vue?vue&type=script&lang=js&"
export * from "./PortfolioBoxLayoutPage.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports